// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetSelectedCityPayload} from '../actions/setSelectedCity'

export function setSelectedCityReducer(state: MapState, action: Action<SetSelectedCityPayload>): MapState {

  return {
    ...state,
    selectedCity: action.payload.city,
  }
}
